<section class="container-fluid">
  <div class="row">
    <h1 class="col-fit" aria-label="CIR Highlights">Highlights</h1>
  </div>
  <div class="row" [@cardEntranceFromAbove]="highlights.length">
    @if (!highlightsLoaded && !errorOccurred) {
      <div role="presentation" class="loading">Loading Highlights...</div>
    }
    @else if (errorOccurred === true) {
      <div class="col-12 error-notice" aria-label="Error">An error occurred while trying to load the {{ !showArchive ? 'current' : 'archived' }} highlights. Please refresh the page to try again.</div>
    }
    @if (highlightsLoaded) {
      @if (hasResults) {
        @for (highlight of highlights; track highlight) {
          <cir-pub-highlight
            class="col-12"
            [highlight]="highlight"
          role="presentation"></cir-pub-highlight>
        }
      }
      @else {
        <div class="col-12">No Highlights to Display</div>
      }
    }
  </div>
  <div class="row justify-content-end actions">
    <div class="col-fit">
      @if (!showArchive && !errorOccurred && highlightsLoaded && hasResults) {
        <button
          type="button"
          class="minor"
          [routerLink]="['archive']">View Archived Highlights <i class="fas fa-chevron-right"></i></button>
        }
        @if (showArchive && moreToShow && hasResults) {
          <button
            type="button" class="minor" (click)="viewMore();">More Highlights<i class="fas fa-chevron-right right-icon"></i></button>
          }
        </div>
      </div>
      @if (showArchive && !moreToShow && hasResults) {
        <div class="row" >
          <div class="col-6 bottom-pad">
            All highlights displayed
          </div>
        </div>
      }
    </section>
